import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/OldStudentPreallocation/GetGroupWithPaging",
    method: "get",
    params
  });
}
export function adjust(data) {
  return request({
    url: "/OldStudentPreallocation/AdjustRoom",
    method: "post",
    data
  });
}
export function confirm(data) {
  return request({
    url: "/OldStudentPreallocation/Confirm",
    method: "post",
    data
  });
}
export function batchConfirm(data) {
  return request({
    url: "/OldStudentPreallocation/BatchConfirm",
    method: "post",
    data
  });
}
export function oldStudentDebit(data) {
  return request({
    url: "/OldStudentPreallocation/CreateDebitNote",
    method: "post",
    data
  });
}
export function refuse(data) {
  return request({
    url: "/OldStudentPreallocation/Refuse",
    method: "post",
    data
  });
}
